import React, { useState, useEffect } from "react";
import "./CourseDetail.scss";
import { FiChevronLeft, FiPlay } from "react-icons/fi";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchPlaylist,
  getSession,
  enroleCourse,
} from "../../store/playList/actions";
import { BASE_URL } from "../../config/";
import { getUserId } from "../../utils/authManager";
import { AiOutlinePlus } from "react-icons/ai";
import $ from "jquery";

const CourseDetail = (props) => {
  const [message, setMessage] = useState("");
  useEffect(() => {
    const { id } = props.match.params;
    props.fetchPlaylist({ id });
    props.getSession(id);
  }, []);

  const checkId = async (sessionId) => {
    const checkEnrolement = props.playlistDetail?.enroleCourse.find(
      (id) => id === sessionId
    );
    return checkEnrolement;
  };

  const enroleCourse = async (sessionId, playlistId) => {
    const checkEnrolement = await checkId(sessionId);
    if (checkEnrolement) {
      $(`#enrole-btn-${sessionId}`).text("Enroled");
      $(`#enrole-btn-${sessionId}`).prop("disabled", "true");
      setMessage("Enroled");
    } else {
      await props.enroleCourse({ sessionId, playlistId });
      $(`#enrole-btn-${sessionId}`).text("Enroled");
      $(`#enrole-btn-${sessionId}`).prop("disabled", "true");
      setMessage("Enroled");
    }
  };
  return (
    <div className="CourseDetail-inner">
      <div className="middle container ">
        <div className="d-flex justify-content-start my-3 border-bottom pb-3">
          <button
            className=" btn btn-link mr-3 d-flex align-items-center"
            onClick={() => {
              props.history.goBack();
            }}
          >
            <FiChevronLeft /> Back
          </button>
        </div>
        <div
          className=" jumbotron"
          style={{
            backgroundImage: `url(${BASE_URL}uploads/${props.playlistDetail.playlistDetail.banner})`,
          }}
        ></div>

        <div className="d-flex justify-content-between align-items-start ">
          <div className="">
            <div className="text-center display-4 font-weight-bold w-100">
              {props.playlistDetail?.playlistDetail?.title}
            </div>
            {/* <div className="h3 my-4 font-weight-normal footer-text text-center-mobile ">
              {" "}
              4 Lectures | {props.playlistDetail?.duration} hr |{" "}
              {props.playlistDetail?.created_by?.name}
            </div> */}
          </div>
        </div>

        <p className="h3 text-justify text-muted font-weight-light my-sm-5 text-center-mobile">
          {props.playlistDetail?.playlistDetail?.description}
        </p>
        {props.playlistDetail?.playlistDetail?.created_by?._id ===
          getUserId() && (
          <div className="create my-5 container">
            <div
              className="create-btn shadow-sm"
              onClick={() =>
                props.history.push({
                  pathname: "/create-session",
                  state: {
                    playlistId: props.playlistDetail?.playlistDetail?._id,
                  },
                })
              }
            >
              <div className="center">
                <AiOutlinePlus />
              </div>
              <div className="h3">Create Session</div>
            </div>
          </div>
        )}
        <div className="bg-light p-3  my-5">
          {props.playlistDetail.loading &&
          !props.playlistDetail.sessionList.length ? (
            <div>Loading...</div>
          ) : (
            props.playlistDetail.sessionList.map((item, i) => (
              <div
                className="bg-white p-3 rounded-lg  m-3 d-flex justify-content-start align-items-center shadow-sm flex-column flex-md-row m-2 m-md-4 "
                key={i}
              >
                <div className="h2 px-3 flex-1 border-right mb-4 mb-md-0 border-none-mobile">
                  {item.title}
                </div>
                <div className="h4 px-3 text-center flex-1 border-right text-muted  mb-4 mb-md-0 border-none-mobile">
                  {props.profile.role === "TEACHER"
                    ? `Stream Key: ${item.streamKey}`
                    : "2hr 30min"}
                </div>
                <div className="h4 px-3 text-center flex-1 border-right text-muted mb-4 mb-md-0 border-none-mobile">
                  {props.profile.role === "TEACHER"
                    ? "URL: rtmp://broadcast.api.video/s"
                    : `${props.playlistDetail?.playlistDetail?.created_by?.firstName} ${props.playlistDetail?.playlistDetail?.created_by?.lastName}`}
                </div>
                <div
                  className="h4 px-3 text-right flex-1 text-muted mb-4 mb-md-0 "
                  style={{ display: "flex" }}
                >
                  {" "}
                  <button
                    className="btn btn-free btn-outline-primary ml-auto rounded-5 "
                    onClick={() => {
                      props.history.push({
                        pathname: "/live",
                        state: {
                          streamUrl: item.streamedUrl,
                          broadcasting: item.broadcasting,
                        },
                      });
                    }}
                  >
                    ${item.price}
                  </button>{" "}
                  {props.profile.role !== "TEACHER" && (
                    <button
                      className="btn btn-free btn-outline-primary ml-auto rounded-5 "
                      onClick={() => enroleCourse(item._id, item.playlistId)}
                      id={`enrole-btn-${item._id}`}
                    >
                      Enrole
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  playlistDetail: state.playlist,
  profile: state.profile.profile,
});

export default connect(mapStateToProps, {
  fetchPlaylist,
  getSession,
  enroleCourse,
})(CourseDetail);
